import * as React from "react";
import { formatRut } from "../../helperComponents/InputRut/rutValidate";
import { FaPen, FaTrashAlt, FaTimesCircle, FaEye, FaInfoCircle } from "react-icons/fa";
import { HiOutlineRefresh } from "react-icons/hi";
import { colorStatus } from "./helper/polizaHelper";
import * as moment from "moment";
import "./poliza.scss";

var ListPoliza = function ListPoliza(props) {
  var polizas = props.polizas,
      onSelectedPoliza = props.onSelectedPoliza,
      admin = props.admin;
  /* poliza.status PUEDEN SER => "BORRADOR" , "VIGENTE", "NO VIGENTE"
  poliza.sub_status PUEDEN SER => "NUEVA", "POR RENOVAR" ..... */

  if (polizas && polizas.length > 0) {
    return /*#__PURE__*/React.createElement("table", {
      className: "table table-striped table-sm table-bordered cntListPoliza col-md-10",
      "data-toggle": "table"
    }, /*#__PURE__*/React.createElement("thead", {
      className: "tableHeader"
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Propuesta"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "N\xBA P\xF3liza"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Estado"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "End"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Compa\xF1\xEDa"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Asegurado"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Materia"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Inicio Vigencia"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Fin Vigencia"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Ramo"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Prima Total"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Forma de pago"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Fecha de env\xEDo P\xF3liza"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Acciones"))), /*#__PURE__*/React.createElement("tbody", {
      className: "tableBody"
    }, polizas && polizas.map(function (poliza) {
      return /*#__PURE__*/React.createElement("tr", {
        key: poliza.id
      }, /*#__PURE__*/React.createElement("th", {
        scope: "row"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id)
      }, poliza.id)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
        href: "#polizaModal",
        "data-toggle": "modal",
        "data-target": "#polizaModal",
        onClick: function onClick() {
          return onSelectedPoliza && onSelectedPoliza(poliza);
        }
      }, poliza.code ? poliza.code : "Ver", /*#__PURE__*/React.createElement(FaEye, null))), /*#__PURE__*/React.createElement("td", null, colorStatus(poliza.status_name), " ", poliza.status_name, poliza.substatus_name ? " - ".concat(poliza.substatus_name) : ""), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id, "/poliza_endorsements"),
        target: "_blank"
      }, poliza.poliza_endorsements_count || 0)), /*#__PURE__*/React.createElement("td", null, poliza.company ? poliza.company.name : "-"), /*#__PURE__*/React.createElement("td", null, poliza.asegurado ? "".concat(poliza.asegurado.name, " ").concat(formatRut(poliza.asegurado.rut || "")) : "-"), /*#__PURE__*/React.createElement("td", null, poliza !== null && poliza !== void 0 && poliza.item_asegurados ? poliza.materia_asegurada_formatted : "-"), /*#__PURE__*/React.createElement("td", null, poliza.start_date ? moment(poliza.start_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", null, poliza.finish_date ? moment(poliza.finish_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", null, poliza.ramo ? poliza.ramo : "-"), /*#__PURE__*/React.createElement("td", null, poliza.currency, " ", poliza.prima_neta ? poliza.prima_neta : "-"), /*#__PURE__*/React.createElement("td", null, poliza.tipo_de_pago ? poliza.tipo_de_pago : "-"), /*#__PURE__*/React.createElement("td", null, poliza.sent_at ? moment(poliza.sent_at).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
        style: {
          minWidth: "250px"
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id),
        className: "btn btn-default btn-mini"
      }, /*#__PURE__*/React.createElement(FaInfoCircle, null)), (admin.is_super_admin || admin.permissions_code.includes("poliza_edit")) && /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id, "/edit"),
        className: "btn btn-default btn-mini"
      }, /*#__PURE__*/React.createElement(FaPen, null)), /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id, "/renew"),
        className: "btn btn-primary"
      }, /*#__PURE__*/React.createElement(HiOutlineRefresh, null)), (admin.is_super_admin || admin.permissions_code.includes("poliza_cancel")) && /*#__PURE__*/React.createElement("a", {
        href: "/api/v1/polizas/".concat(poliza.id, "/cancel"),
        className: "btn btn-danger",
        "data-method": "delete",
        rel: "nofollow",
        "data-confirm": "\xBFEst\xE1s seguro de CANCELAR la p\xF3liza ".concat(poliza === null || poliza === void 0 ? void 0 : poliza.code, "?")
      }, /*#__PURE__*/React.createElement(FaTimesCircle, null)), (admin.is_super_admin || admin.permissions_code.includes("poliza_destroy")) && /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(poliza.id),
        className: "btn btn-danger",
        "data-confirm": "Est\xE1s seguro de ELIMINAR la p\xF3liza ".concat(poliza === null || poliza === void 0 ? void 0 : poliza.code, "?"),
        rel: "nofollow",
        "data-method": "delete"
      }, /*#__PURE__*/React.createElement(FaTrashAlt, null))));
    })));
  }

  return /*#__PURE__*/React.createElement("h3", null, "No se han encontrado P\xF3lizas.");
};

export default ListPoliza;